import { useState } from "react";

const tabs = [
  { text: "About the Trainer" },
  { text: "Qualifications" },
  { text: "Courses Offered" },
  { text: "Reviews" },
];

export default function TrainerDescription() {
  const [activeTab, setActiveTab] = useState(0);

  const trainerData = {
    about: `
      Yessin Rebhi is a leading AI expert with over 8 years of experience in artificial intelligence and machine learning. She is passionate about making AI accessible and helping professionals integrate AI technologies into real-world applications. Yessin's deep understanding of AI algorithms, combined with her ability to explain complex ideas in simple terms, has made her a sought-after trainer in the field.
    `,
    philosophy: `
      Yessin believes that learning AI should be hands-on and interactive. She tailors her teaching approach to encourage critical thinking and creativity, helping learners apply AI techniques to solve practical problems. She emphasizes the importance of ethical AI development and always promotes the responsible use of AI technologies.
    `,
    qualifications: [
      "Ph.D. in Artificial Intelligence from ABC University",
      "Certified Machine Learning Specialist",
      "8+ years of industry and teaching experience in AI and ML",
      "Contributor to several open-source AI projects"
    ],
    courses: [
      {
        title: "Introduction to Artificial Intelligence",
        description: "A foundational course exploring the basics of AI, including its history, core concepts, and future potential."
      },
      {
        title: "Deep Learning with Neural Networks",
        description: "A hands-on course teaching the fundamentals of neural networks and their applications in deep learning."
      },
      {
        title: "AI Ethics and Responsible AI",
        description: "A comprehensive overview of the ethical considerations and challenges in AI development and deployment."
      }
    ],
    reviews: [
      { text: "Yessin's course on deep learning was a game-changer for me. Her explanations were clear and the hands-on projects really solidified my understanding.", author: "Emma Wilson" },
      { text: "The best AI training I've ever had! Yessin's passion and expertise are evident in every lesson.", author: "Michael Lee" },
      { text: "I loved the balance between theory and practice in Yessin's AI courses. I now feel confident using AI in my projects.", author: "Sophia Brown" }
    ]
  };

  return (
    <div className="tabs-description">
      <div className="section-container">
        <div className="row">
          <div className="col-12">
            <div className="widget-tabs">
              <ul className="widget-menu-tab">
                {tabs.map((elm, i) => (
                  <li
                    onClick={() => setActiveTab(i)}
                    key={i}
                    className={`item-title ${activeTab === i ? "active" : ""}`}
                  >
                    <span className="inner">{elm.text}</span>
                  </li>
                ))}
              </ul>
              <div className="widget-content-tab">
                {activeTab === 0 && (
                  <div className="widget-content-inner fadeTabContent active">
                    <p>{trainerData.about}</p>
                    <h4>Teaching Philosophy:</h4>
                    <p>{trainerData.philosophy}</p>
                  </div>
                )}
                {activeTab === 1 && (
                  <div className="widget-content-inner fadeTabContent active">
                    <h4>Qualifications:</h4>
                    <ul>
                      {trainerData.qualifications.map((qualification, index) => (
                        <li key={index}>{qualification}</li>
                      ))}
                    </ul>
                  </div>
                )}
                {activeTab === 2 && (
                  <div className="widget-content-inner fadeTabContent active">
                    <h4>Courses Offered:</h4>
                    <ul>
                      {trainerData.courses.map((course, index) => (
                        <li key={index}>
                          <strong>{course.title}:</strong> {course.description}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
                {activeTab === 3 && (
                  <div className="widget-content-inner fadeTabContent active">
                    <h4>Reviews:</h4>
                    {trainerData.reviews.map((review, index) => (
                      <p key={index}>
                        "{review.text}" - <strong>{review.author}</strong>
                      </p>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
